import { createDomain } from 'effector';

import api from 'api';

const domain = createDomain('api/q-instances');

const QInstancesFxs = {
    getChangesFx: domain.effect(api.qInstances.getChanges),
    createIncludedInstanceFx: domain.effect(api.qInstances.createIncludedInstance),
    createInstanceFx: domain.effect(api.qInstances.createInstance),
    deleteInstanceFx: domain.effect(api.qInstances.deleteInstance),
    getDocumentsForQInstanceFx: domain.effect(api.qInstances.getDocumentsForQInstance),
    getDocumentTypesForQInstanceFx: domain.effect(api.qInstances.getDocumentTypesForQInstance),
    getInstancesFx: domain.effect(api.qInstances.getInstances),
    getJobStatusFx: domain.effect(api.qInstances.getJobStatus),
    getNotifiableParticipantsFx: domain.effect(api.qInstances.getNotifiableParticipants),
    getQInstanceFx: domain.effect(api.qInstances.getQInstance),
    getSummaryFx: domain.effect(api.qInstances.getSummary),
    isPaymentOkFx: domain.effect(api.qInstances.isPaymentOk),
    loadChildrenFx: domain.effect(api.qInstances.loadChildren),
    rollbackFx: domain.effect(api.qInstances.rollback),
    setLocationFx: domain.effect(api.qInstances.setLocation),
    setStatusFx: domain.effect(api.qInstances.setStatus),
    setToBeMailedFx: domain.effect(api.qInstances.setToBeMailed),
    shipDocsFx: domain.effect(api.qInstances.shipDocs),
    startPaymentFx: domain.effect(api.qInstances.startPayment),
    updateNotifiableSettingsFx: domain.effect(api.qInstances.updateNotifiableSettings),
    sendInvoiceFx: domain.effect(api.qInstances.sendInvoice),
};

export default QInstancesFxs;
